import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from "axios";
import { print } from "graphql";
import { embeddedConfig } from "@catchoftheday/env-config";
import { injectEdgeAuthHeaders } from "../utils";
export var ServerGQLClientError = /*#__PURE__*/_createClass(function ServerGQLClientError(_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      errorMessage = _ref.errorMessage,
      data = _ref.data;

  _classCallCheck(this, ServerGQLClientError);

  _defineProperty(this, "graphQLErrors", void 0);

  _defineProperty(this, "errorMessage", void 0);

  _defineProperty(this, "data", void 0);

  this.graphQLErrors = graphQLErrors || [];
  this.errorMessage = errorMessage;
  this.data = data || null;
});

/**
 * A simple GraphQL client based on Axios, which is exclusively used for server-side rendering.
 * This is to be used in instances where you don't need Apollo Client's cache to be populated during SSR.
 */
export var ServerGQLClient = /*#__PURE__*/function () {
  function ServerGQLClient(_ref2) {
    var uri = _ref2.uri,
        _clientHeaders = _ref2.headers;

    _classCallCheck(this, ServerGQLClient);

    _defineProperty(this, "uri", void 0);

    _defineProperty(this, "clientHeaders", void 0);

    _defineProperty(this, "mutate", this.query);

    this.uri = uri; // Set default headers

    this.clientHeaders = _objectSpread(_objectSpread({}, _clientHeaders ? injectEdgeAuthHeaders(_clientHeaders) : undefined), {}, {
      cookie: (_clientHeaders === null || _clientHeaders === void 0 ? void 0 : _clientHeaders.cookie) || "",
      "user-agent": embeddedConfig.APP_NAME,
      "content-type": "application/json",
      "x-forwarded-host": (_clientHeaders === null || _clientHeaders === void 0 ? void 0 : _clientHeaders["x-forwarded-host"]) || (_clientHeaders === null || _clientHeaders === void 0 ? void 0 : _clientHeaders.host),
      "x-ssr-origin": (_clientHeaders === null || _clientHeaders === void 0 ? void 0 : _clientHeaders["x-forwarded-host"]) || (_clientHeaders === null || _clientHeaders === void 0 ? void 0 : _clientHeaders.host)
    });
  }

  _createClass(ServerGQLClient, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var _query, variables, queryHeaders, queryBody, response, responseAsErrorPayload;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _query = _ref3.query, variables = _ref3.variables, queryHeaders = _ref3.headers;

                if (this.uri) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", {
                  error: new ServerGQLClientError({
                    errorMessage: "ServerGQLClient: uri is not defined"
                  })
                });

              case 3:
                queryBody = print(_query);

                if (queryBody) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", {
                  error: new ServerGQLClientError({
                    errorMessage: "Make sure the provided query is valid"
                  })
                });

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return axios.post(this.uri, {
                  query: queryBody,
                  variables: variables
                }, {
                  headers: _objectSpread(_objectSpread({}, this.clientHeaders), queryHeaders)
                });

              case 9:
                response = _context.sent;
                // If GraphQL error, we status code will still be 200 and hence we need to check for errors manually
                responseAsErrorPayload = response.data;

                if (!(responseAsErrorPayload !== null && responseAsErrorPayload !== void 0 && responseAsErrorPayload.errors)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", {
                  error: new ServerGQLClientError({
                    graphQLErrors: responseAsErrorPayload.errors,
                    data: (responseAsErrorPayload === null || responseAsErrorPayload === void 0 ? void 0 : responseAsErrorPayload.data) || null
                  })
                });

              case 13:
                return _context.abrupt("return", {
                  data: response.data.data
                });

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);
                return _context.abrupt("return", {
                  error: new ServerGQLClientError({
                    graphQLErrors: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.errors,
                    data: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.data,
                    errorMessage: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
                  })
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16]]);
      }));

      function query(_x) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return ServerGQLClient;
}();